'use strict';

function GridReadOnlyModalController() {}
GridReadOnlyModalController.$inject = [];
module.exports = GridReadOnlyModalController;